export const API_BASE_URL =
    process.env.REACT_APP_API_BASE_URL || 'https://mighty-taiga-90294.herokuapp.com/api';



// WEBPACK FOOTER //
// ./src/config.js